import { createApi } from '@reduxjs/toolkit/dist/query/react';
import B2ChatClient, { apiResource, b2chatBaseQuery } from '@src/client';
import type { LoginSuccess } from '@src/types';
import timeout from '@src/utils/timeout';

export type Profile = {
  fullName: string;
  mobileNumber: string;
  email: string;
  avatarUrl: string;
  role: string;
};

type GetMeResponse = Profile & {
  status: 'ACTIVE' | 'INACTIVE';
  mobileAccess: 'ACTIVE' | 'INACTIVE';
  canReceiveCalls: boolean;
  chatDeletePolicy: boolean;
  admin: boolean;
  agent: boolean;
  aggregator: boolean;
  marketing: boolean;
  auditor: boolean;
  localUsername: string;
  role: string;
};

type UpdateMeRequest = Profile;

type UpdateMeResponse = Profile;

export const UsersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: b2chatBaseQuery,
  tagTypes: ['user-me'],
  endpoints: builder => ({
    getUserMe: builder.query<GetMeResponse, void>({
      query: () => apiResource(B2ChatClient.resources.users.actions.getMe, {}),
      providesTags: ['user-me'],
    }),
    updateUserMe: builder.mutation<UpdateMeResponse, UpdateMeRequest>({
      query: data =>
        apiResource(B2ChatClient.resources.users.actions.updateMe, {
          data,
        }),
      extraOptions: {
        maxRetries: 0,
      },
      onCacheEntryAdded: async (_, api) => {
        await timeout(2000);
        api.dispatch(UsersApi.util.invalidateTags(['user-me']));
      },
    }),
    getCurrentUser: builder.query<LoginSuccess, void>({
      query: () =>
        apiResource(B2ChatClient.resources.user.actions.getCurrentUser, {}),
      providesTags: ['user-me'],
      extraOptions: {
        maxRetries: 1,
      },
    }),
  }),
});

export const {
  useGetUserMeQuery,
  useUpdateUserMeMutation,
  useGetCurrentUserQuery,
} = UsersApi;
